/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_Final_Seat_ConfirmInputs */



/**
* | output |
* | --- |
* | "Seat these finalists" |
*
* @param {League_Final_Seat_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_final_seat_confirm = /** @type {((inputs?: League_Final_Seat_ConfirmInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_Final_Seat_ConfirmInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Placer ces finalistes")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sentar a estos finalistas")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Sentar estes finalistas")
	if (locale === "it") return /** @type {LocalizedString} */ ("Disponi questi finalisti")
	return /** @type {LocalizedString} */ ("Seat these finalists")
});